import EventTypes from "../../../shared/EventTypes";
import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ChangeSegmentTypeAction extends AbstractProvidedClass {
    constructor(provider, element, segmentIndex, newType) {
        super(provider);
        this.element = element;
        this.segmentIndex = segmentIndex;
        this.newType = newType;
        this.oldSegment = element.segments[segmentIndex];
        this.oldType = this.oldSegment.type;
    }

    update() {}

    finish() {
        if (this.oldType === this.newType) {
            this.actions.discard();
            return;
        }
        this.element.changeSegmentType(this.segmentIndex, this.newType);
        this.newSegment = this.element.segments[this.segmentIndex];
        this.actions.finish();
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    undo() {
        this.element.restoreSegment(this.segmentIndex, this.oldSegment);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }

    redo() {
        this.element.restoreSegment(this.segmentIndex, this.newSegment);
        this.emit(EventTypes.UPDATE_ELEMENT_SHAPE, this.element);
    }
}
